import React from "react";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import { Container } from "@mui/material";
import { Typography } from "@mui/material";
import Mang from "../layout/Mang";
const Header = () => {
  return (
    <>
    <Container maxWidth="md" > 
      <Grid container spacing={3}>
        <Grid item xs={12} sx={{display:"flex" , justifyContent:"center" , alignContent:"flex-end" , marginTop:"3rem"  }}>
           <Mang />
        </Grid>
        <Grid item xs={12} sx={{display:"flex" , justifyContent:"center" , }}>
        <Paper
            sx={{
              display: "flex",
              justifyContent: "center",
              alignContent: "center",
              marginTop: "1rem",
              marginBottom: "1rem",
              padding: "1rem",
              background: "rgba(255, 173, 1, 0.5)",
              width: "60%",
              borderRadius: "10px",
            }}
          >
            <Typography
              variant="h6"
              component="div"rem
              sx={{ flexGrow: 1, display: "flex", justifyContent: "center" , color:"white" }}
            >
              Hello, i'm a front-end developer based in cairo!
            </Typography>
          </Paper>
        </Grid>
      </Grid>
      </Container>
    </>
  );
};

export default Header;
